import React, { Component } from 'react';
import './Benvenuto.css';
import stck from '../../images/public/login/stck.png';
import logo from '../../images/public/login/logo.png';
import wstu from '../../images/public/login/wstu.png';
import bnvt from '../../images/public/registeration/bnvt.png';
import clos from '../../images/public/registeration/clos.png';
import { element } from 'prop-types';
import classNames from 'classnames';
import { BrowserView, MobileView, isBrowser, isMobile, isFirefox, isTablet, isMobileOnly, isAndroid, isIOS, browserName } from 'react-device-detect';
import { Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle } from 'react-shapes';
import { Button } from 'react-bootstrap';
import { RadioGroup, Radio } from 'react-radio-group';
import { height } from 'window-size';
import WebFont from 'webfontloader';
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import tr from '../../libs/tr'
import AlertPnl from "../../assets/components/panel/AlertPnl";
import RadioVerTwo from '../../assets/components/radiobtn/RadioVerTwo'
import WaitLoad from "../../assets/components/loading/WaitLoad";
import { userFetch, checkCart } from '../../libs/fetch'
import Cookies from 'universal-cookie';
const cookies = new Cookies();
class Benvenuto extends Component {
    constructor(props) {
        super(props);

        console.log('[Benvenuto father]', props);

        this.state = {
            newCard: true,
            loadedData: false,
            isLoading: false,
            errmsg: null,
            errorFlg: false,
        };
    }

    componentDidMount() {
        this.userFetch()
    }

    gotoNextPage = (e) => {
        e.preventDefault();
        console.log("[Benvenuto] gotoNextPage");
        return this.state.newCard == true ? this.props.history.push('/Dovesciare') : this.props.history.push('/Inseriscicard');
    }

    RadioVerTwoCB(info) {
        console.log("[Benvenuto] RadioVerTwoCB:", info);
        this.setState({ newCard: info == "0" ? true : false });
    }

    //getting user info
    userFetch = () => {
        console.log("[Benvenuto] userFetch");

        this.forceUpdate(() => {
            let access_token = cookies.get('access_token');
            let params = { access_token: access_token };
            userFetch(this, params)
                .then((response) => {
                    console.log("[Benvenuto] userFetch @response: ", response);
                    if (response.id_ut) {
                        localStorage.setItem('user', JSON.stringify(response));
                        this.checkCart();
                    } else {
                        this.setState({
                            errorFlg: true,
                            errmsg: "ERROR!"
                        });
                    }
                });
            return
        })
    }



    //this call is used to add new Card into the purchase cart
    checkCart = () => {
        let access_token = cookies.get('access_token');
        let params = {};
        checkCart(this, access_token, params)
            .then((response) => {
                console.log("[Benvenuto] checkCart @response: ", response);
                if (response.status == "success") {
                    this.setState({ strPurchaseCard: response.cart });
                    return this.createCart();
                } else {
                    // this.setState({
                    //     errorFlg: true,
                    //     errmsg: response.message
                    // });
                }
            });
        return
    }

    //This function is used to re format the received string from checkCart into purchaseCart
    createCart = () => {
        let strPurchaseCard = this.state.strPurchaseCard;
        let sepStrArr = null;
        let purchaseCart = [];
        this.setState({ isLoading: true });
        this.forceUpdate(() => {
            console.log("[Benvenuto] createCart, @strPurchaseCard: ", this.state.strPurchaseCard);
            if (strPurchaseCard) sepStrArr = strPurchaseCard.split("_");
            console.log("[Benvenuto] createCart, @sepStrArr: ", sepStrArr);
            if (sepStrArr && sepStrArr.length > 0) {
                for (let i = 0; i < Number(sepStrArr[0]) + Number(sepStrArr[1]); i++) {
                    purchaseCart.push({
                        number_of_services_adult: sepStrArr[0],
                        number_of_services_reduced: sepStrArr[1],
                        code: sepStrArr[2].split(",")[i],
                        provider: sepStrArr[3].split(",")[i],
                        type: sepStrArr[4].split(",")[i],
                        shipment: sepStrArr[5].split(",")[i],
                        name: sepStrArr[6].split(",")[i],
                        surname: sepStrArr[7].split(",")[i],
                        date_of_birth: sepStrArr[8].split(",")[i],
                        gender: sepStrArr[9].split(",")[i],
                        item_id: sepStrArr[10].split(",")[i],
                    });
                }
            };
            console.log("[Benvenuto] createCart, @purchaseCart: ", purchaseCart);
            this.setState({ purchaseCart, isLoading: false });
            localStorage.setItem("purchaseCart", JSON.stringify(purchaseCart));
        });
    }

    alertResponse(info) {
        switch (info.type) {
            case "closeButton":
                this.setState({ errorFlg: false })
                break;
            case "actionButton":
                if (info.option1 == "attention") {
                    this.setState({ errorFlg: false })
                    break;
                }
        }
    }

    render() {
        console.log('[Benvenuto]', this.state);

        return (
            <Router>
                <div>
                    <div>
                        <BrowserView>
                            <div className="containermbcgbb">
                                {tr.userlng() == 'IT' && <div className="navbi"></div>}
                                {tr.userlng() != 'IT' && <div className="navbe"></div>}
                                <div className="containermbb">
                                    <div className="stck">
                                        <img src={stck} className="rspn" />
                                    </div>
                                    <div className="closb">
                                        <a onClick={() => { return this.props.history.push('/') }}>
                                            <img src={clos} className="rspn" />
                                        </a>
                                    </div>
                                    <div className="spcb1"></div>
                                    <div className="logo">
                                        <img src={logo} className="rspn" />
                                    </div>
                                    <div className="spcb2"></div>
                                    <div className="bnvt">
                                        {tr.t("Welcome")}
                                    </div>
                                    <div className="containersbb">
                                        <form>
                                            <RadioVerTwo context01={tr.t("Idonthave")} context02={tr.t("Ihave")} callback={this.RadioVerTwoCB.bind(this)} />
                                        </form>
                                        <div className="spcb3"></div>
                                    </div>
                                    {/* {this.state.errorFlg && <div className="warnb">{this.state.errmsg}</div>} */}
                                    <div className="containerbbb">
                                        <form>
                                            <button disabled={this.state.errorFlg} className="bbtn" onClick={this.gotoNextPage}>{tr.t("Next")}</button>
                                        </form>
                                    </div>
                                    <div className="containerzbb">
                                        <div>{tr.t("Later")}</div>
                                        <a className="txlb" onClick={() => { return this.props.history.push('/') }}>
                                            {tr.t("Goto")}
                                        </a>
                                    </div>
                                    <div className="marginBottomb"></div>
                                </div>
                            </div>
                        </BrowserView>
                        <MobileView>
                            <div className="containermbcgbm">
                                {/* <div className="navbm"></div> */}
                                <div className={(isMobileOnly || isAndroid) ? "containermbm" : "containermbt"} style={{ flex: 1 }}>
                                    <div className="stckm">
                                        <img src={stck} className="rspn" />
                                    </div>
                                    <div className="closbm">
                                        <a onClick={() => { return this.props.history.push('/') }}><img src={clos} className="rspn" /></a>
                                    </div>
                                    <div className="logom">
                                        <img src={logo} className="rspn" />
                                    </div>
                                    <div className="spcb2"></div>
                                    <div className="bnvtm">
                                        {tr.t("Welcome")}
                                    </div>
                                    <div className={(isMobileOnly || isAndroid) ? "containersbm" : "containersbt"}>
                                        <form>
                                            <RadioVerTwo mobileFont={true} context01={tr.t("Idonthave")} context02={tr.t("Ihave")} callback={this.RadioVerTwoCB.bind(this)} />
                                        </form>
                                        <div className="spcb3"></div>
                                    </div>
                                    {/* {this.state.errorFlg && <div className="warnbm">{this.state.errmsg}</div>} */}
                                    <div className={(isMobileOnly || isAndroid) ? "containerbbm" : "containerbbt"}>
                                        <form>
                                            <button disabled={this.state.errorFlg} className="bbtnm" onClick={this.gotoNextPage}>{tr.t("Next")}</button>
                                        </form>
                                    </div>
                                    <div className={(isMobileOnly || isAndroid) ? "containerzbm" : "containerzbt"}>
                                        <div>{tr.t("Later")}</div>
                                        <a className="txlbm" onClick={() => { return this.props.history.push('/') }}>
                                            {tr.t("Goto")}</a>
                                    </div>
                                </div>
                            </div>
                        </MobileView>
                        {this.state.errorFlg ?
                            <div className="containerModalb">
                                {this.state.errorFlg ?
                                    <AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.errmsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
                                }
                            </div> : null
                        }
                    </div>
                    <WaitLoad enable={this.state.isLoading} />
                </div>
            </Router>
        );
    }
}

export default Benvenuto;


// WEBPACK FOOTER //
// ./src/screens/Benvenuto/Benvenuto.js